<div class="confirm-dialog-overlay" *ngIf="dialogVisible">
  <div class="confirm-dialog">
    <h2>{{ dialogTitle }}</h2>
    <p>{{ dialogMessage }}</p>

    <div class="dialog-actions">
      <button
        [ngClass]="getButtonClass()"
        (click)="onConfirm()">
        Подтвердить
      </button>
      <button (click)="onCancel()" class="cancel-button">
        Отмена
      </button>
    </div>
  </div>
</div>
